import { render, staticRenderFns } from "./FourLists.vue?vue&type=template&id=640045be&scoped=true&"
import script from "./FourLists.vue?vue&type=script&lang=js&"
export * from "./FourLists.vue?vue&type=script&lang=js&"
import style0 from "./FourLists.vue?vue&type=style&index=0&id=640045be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640045be",
  null
  
)

export default component.exports